import {
  IReduxActionProps,
  IReduxPayloadProps,
} from './../../../../Utils/index';
export const SET_FACETS = 'SET_FACETS';

export const setFacets = (facets: IReduxPayloadProps): IReduxActionProps => {
  return {
    type: SET_FACETS,
    payload: facets,
  };
};
